import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import UploadPic from "../../../components/UploadPic/UploadPic";

export default function P216Dialog({ dialog, setDialog, dataFile, setDataFile, onSaveFile, typeFile }) {
    useEffect(() => {
        if (dialog && dialog.act && dialog.act === "reload") {
            setDialog({ dialog: true, show: true });
        }
    }, [dialog.act]);

    return (
        <Dialog header="เพิ่มไฟล์" visible={dialog.dialog} style={{ width: "45vw" }} className="p-fluid ___widthDialog" onHide={() => setDialog({ dialog: false, show: false })} blockScroll={true} maximizable={true}>
            {dialog && dialog.show === true ? <UploadPic setDialog={setDialog} dataFile={dataFile} setDataFile={setDataFile} onSaveFile={onSaveFile} typeFile={typeFile} /> : null}
        </Dialog>
    );
}
